// extracted by mini-css-extract-plugin
export default {"flavors_select_drawer":"C3","nutrition_facts":"E3","nutrition_accordeon":"F3","title":"G3"};
    if(module.hot) {
      // 1713996751040
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  